import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

type LinkButtonSecondaryComponentProps = {
  children: React.ReactNode
  className?: string
  href: string
}

const LinkButtonSecondaryStyle = styled(Link)`
  display: inline-block;
  background: white;
  border-radius: 25px;
  color: #393432;
  font-weight: bold;
  text-decoration: none;
  padding: 10px 20px 10px;

  :hover {
    background: #dfdfdf;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    height: 1.25rem;
  }
`;

const LinkButtonSecondary: React.FC<LinkButtonSecondaryComponentProps> = ({ children, className, href }) => {
  return (
    <LinkButtonSecondaryStyle className={className} to={href}>
      { children }
    </LinkButtonSecondaryStyle>
  );
};

export default LinkButtonSecondary;
